export enum PainFilterOption {
    ALL = "All",
    YES = "Yes",
    NO = "No",
}

export const PainFilterOptionToTranslationKey: Record<PainFilterOption, string> = {
    [PainFilterOption.ALL]: "general.all",
    [PainFilterOption.YES]: "general.yes",
    [PainFilterOption.NO]: "general.no",
};